import { render, staticRenderFns } from "./FilterCentro.vue?vue&type=template&id=bdef22da"
import script from "./FilterCentro.vue?vue&type=script&lang=js"
export * from "./FilterCentro.vue?vue&type=script&lang=js"
import style0 from "./FilterCentro.vue?vue&type=style&index=0&id=bdef22da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports